<app-header (toggle)="setSidebarVisibility()"></app-header>

<div [@slideInOut]="menuState" class="sid-sidenav bg-dark">
   <app-menu></app-menu>
</div>
<div class="sid-main" [@slideMap]="menuState">
   <router-outlet></router-outlet>
</div>
